<tax-page-header [titleText]="retailPlaceTitle" [dropdownItems]="dropdownItems"></tax-page-header>

<div class="ui-kit-content-container">
  <tax-input
    class="user__parameter"
    [required]="true"
    labelText="retail.place.title"
    id="title"
    [(ngModel)]="retailPlace.title"
    [autofocus]="true"
    [layoutColumns]="2"
    [clearable]="true"
    (keydown.enter)="submit()"
    data-qa-input="retail-place-name"
  ></tax-input>

  <hr class="greyline" />

  <div data-qa-block="retail-place-info">
    <div class="user__parameter upper">
      <span translate data-qa="id-title">kkm.settings.id</span>
      <span data-qa="id">{{ retailPlace?.id }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="region-title">retail.place.region</span>
      <span data-qa="region">{{ retailPlace?.area }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="city-title">retail.place.city</span>
      <span data-qa="city">{{ retailPlace?.city }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="street-title">address.modal.street</span>
      <span data-qa="street">{{ retailPlace?.street }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="house-title">retail.place.house</span>
      <span data-qa="house">{{ retailPlace?.house }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="building-title">address.modal.building</span>
      <span data-qa="building">{{ retailPlace?.housing }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="apartment-title">retail.place.apartment</span>
      <span data-qa="apartment">{{ retailPlace?.apartment }}</span>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="vpn-id-title">VPN id</span>
      <ng-template [ngIf]="retailPlace?.vpnStatus === 1">
        <span translate data-qa="vpn-id">retailPlace.vpn.status.connecting</span>
      </ng-template>
      <ng-template [ngIf]="retailPlace?.vpnStatus === 2">
        <span data-qa="vpn-id">{{ retailPlace.channelId }}</span>
      </ng-template>
      <ng-template [ngIf]="retailPlace?.vpnStatus === 3">
        <span translate data-qa="vpn-id">retailPlace.vpn.status.fail</span>
      </ng-template>
    </div>

    <div class="user__parameter upper">
      <span translate data-qa="kkms-counter-title">kkms.title</span>
      <div data-qa="kkms-counter">
        {{ retailPlace?.kkms?.length }},
        {{ 'common.kkm.online-status.online.low' | translate }}
        {{ retailPlace?.kkmsOnlineCount }}
      </div>
    </div>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="goToRetailPlace()" translate>
      group.back
    </button>
    <button
      data-qa-button="save"
      class="button_blue"
      [disabled]="isTitleSame()"
      (click)="submit()"
      translate
    >
      organization.save
    </button>
  </div>
</div>
